import { notificationManagement } from "../../constants/actionTypes";

const INITIAL_STATE = {
  notificationMaangementGetData: "",
  ntfyMnmgtCreateData: "",
  ntfyMnmgtUpdateData: "",
  myNotificationData: "",
  userNotificationData: [],
  deleteNotificationData: "",
  notificationCreateError: "",
  notificationUpdateError: "",
  deleteNotificationError: "",
  notificationDefaultList: "",
  notificationSendSuccess: "",
  notificationSendError: "",
};

const notificationManagementReducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case notificationManagement.NOTIFICATION_GET_MANAGEMENT_SUCCESS:
      return {
        ...state,
        notificationMaangementGetData: action.data,
      };
    case notificationManagement.NOTIFICATION_MANAGEMENT_CREATE_SUCCESS:
      return {
        ...state,
        ntfyMnmgtCreateData: action.data,
      };
    case notificationManagement.NOTIFICATION_MANAGEMENT_UPDATE_SUCCESS:
      return {
        ...state,
        ntfyMnmgtUpdateData: action.data,
      };
    case notificationManagement.MY_NOTIFICATION_MANGEMENT_GET_SUCCESS:
      return {
        ...state,
        myNotificationData: action.data,
      };
    case notificationManagement.USERS_NOTIFICATION_MANGEMENT_GET_SUCCESS:
      return {
        ...state,
        userNotificationData: action.data,
      };
    case notificationManagement.NOTIFICATION_MANAGEMENT_DELETE_SUCCESS:
      return {
        ...state,
        deleteNotificationData: action.data,
      };
    case notificationManagement.NOTIFICATION_MANAGEMENT_CREATE_ERROR:
      return {
        ...state,
        notificationCreateError: action.data,
      };
    case notificationManagement.NOTIFICATION_MANAGEMENT_UPDATE_ERROR:
      return {
        ...state,
        notificationUpdateError: action.data,
      };
    case notificationManagement.NOTIFICATION_MANAGEMENT_DELETE_ERROR:
      return {
        ...state,
        ntfyMngmntDeleteError: action.data,
      };
    case notificationManagement.NOTIFICATION_MANAGEMENT_DEFAULT_SUCCESS:
      return {
        ...state,
        notificationDefaultList: action.data,
      };
    case notificationManagement.NOTIFICATION_MANAGEMENT_SEND_SUCCESS:
      return {
        ...state,
        notificationSendSuccess: action.data,
      };
    case notificationManagement.NOTIFICATION_MANAGEMENT_SEND_ERROR:
      return {
        ...state,
        notificationSendError: action.data,
      };
    case notificationManagement.NOTIFICATION_MANGEMENT_GET_ERROR:
      return {
        ...state,
        ntfyMngmntListError: action.data,
      };
    default:
      return state;
  }
};

export default notificationManagementReducer;
